class UserData {

    id = null;
    email = '';
    idCompany = null;
    first_name = '';
    last_name = '';
    valid_until = null;
    roles = [];
    rights = [];
    settings = {};
    language = 'en';
    timezone = 'UTC';
    formats = {};
/*
    formatFullDate = 'DD.MM.YYYY';
    formatMonthYear = 'MM.YYYY';
    formatFullTime = 'HH:mm:ss';
    formatHourMinute = 'HH:mm';
    formatDatetime = 'DD.MM.YYYY HH:mm';

    formatedDate = 'MM-DD-YYYY';
    formatedDate2 = 'MM-YYYY';
    formatedTime = 'HH:mm';
    formatedTime2 = 'HH:mm:ss';
    formatedDatetime = 'MM-DD-YYYY HH:mm';
*/
    initialized = false;
    api_enabled = false;
    ai_connector_enabled = false;

    constructor(result) {

        if (result) {
            this.id = result.id;
            this.email = result.email;
            this.idCompany = result.id_company;
            this.first_name = result.first_name;
            this.last_name = result.last_name;
            this.valid_until = +(result.valid_until);
            this.licenced_from = +(result.licenced_from);
            this.licenced_till = +(result.licenced_till);
            this.roles = result.roles ? result.roles.split(';') : [];
            this.rights = result.rights;
            this.settings = result.settings;
            this.api_enabled = (result.api_enabled == 1 || result.api_enabled === true || result.api_enabled === 'true');
            this.ai_connector_enabled = (result.ai_connector_enabled == 1 || result.ai_connector_enabled === true || result.ai_connector_enabled === 'true');

            if (this.language) this.language = result.language;
            if (this.settings === null || typeof this.settings !== 'object') this.settings = {};

            this.timezone = result.timezone;

            if (result.datetime) this.formats['datetime'] = result.datetime;
            if (result.fullDate) this.formats['fullDate'] = result.fullDate;
            if (result.fullTime) this.formats['fullTime'] = result.fullTime;
            if (result.hourMinute) this.formats['hourMinute'] = result.hourMinute;
            if (result.monthYear) this.formats['monthYear'] = result.monthYear;
/*
            if (result.formatedDate) this.formatedDate = result.formatedDate;
            if (result.formatedDate2) this.formatedDate2 = result.formatedDate2;
            if (result.formatedTime) this.formatedTime = result.formatedTime;
            if (result.formatedTime2) this.formatedTime2 = result.formatedTime2;
            if (result.formatDatetime) this.formatDatetime = result.formatDatetime;
*/
            this.initialized = true;
        }

    }

}

export default UserData;
